import apiClient from './config';

export default {
  // Récupérer toutes les transactions
  getAllTransactions(params = {}) {
    return apiClient.get('/firm/transactions', { params });
  },

  // Créer une nouvelle transaction
  createTransaction(data) {
    return apiClient.post('/firm/transactions', data);
  },

  // Finaliser le paiement (CASH, CHQ, OTHER)
  checkout(data) {
    return apiClient.post('/firm/transactions/checkout', data);
  },

  // Créer un lien de paiement Stripe avec QR Code
  createPaymentLink(data) {
    return apiClient.post('/firm/transactions/create-payment-link', data);
  },

  // Vérifier et enregistrer un paiement Stripe
  verifyStripePayment(sessionId) {
    return apiClient.post('/firm/transactions/verify-stripe-payment', { sessionId });
  },

  // Initier un paiement TPE
  initiateTpePayment(data) {
    return apiClient.post('/firm/transactions/tpe-payment', data);
  },

  // Générer un reçu
  generateReceipt(transactionId) {
    return apiClient.post(`/firm/transactions/${transactionId}/receipt`);
  },

  // Récupérer le résumé quotidien
  getDailySummary(date) {
    return apiClient.get('/firm/transactions/daily-summary', { params: { date } });
  },

  // Exporter les transactions
  exportTransactions(params = {}) {
    return apiClient.post('/firm/transactions/export', params, {
      responseType: 'blob',
    });
  },

  // Clôturer la journée
  closeDailyRegister() {
    return apiClient.get('/firm/transactions/close-daily');
  },

  // Marquer un paiement comme payé
  markAsPaid(paymentId) {
    return apiClient.patch(`/firm/payments/${paymentId}/mark-paid`);
  },

  // Récupérer les statistiques de paiement
  getPaymentStats(params = {}) {
    return apiClient.get('/firm/payments/stats', { params });
  },
};
